import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { Tweens } from "../Components/Effects/Tweens";

/**
 * Reel2 handles:
 * - z-order
 * - usage of Normal instead of Rotation
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Reel2 extends Reel {
    public static Tease: boolean = false;

    public spinStop(force: boolean = false, customDelay: number = 0, useCustomDelay: boolean = false): void {
        this.stopTimer.stop();

        if (force) {
            this.rollSpeed = this.forceSpeed;

            if (useCustomDelay) {
                this.stopTimer.start(customDelay);
            } else {
                this.shouldBeStopping = true;
            }
        } else {
            this.stopTimer.start(customDelay !== 0 ? customDelay : this.stopDelay);
        }
    }

    //******************************************************************************************************************
    //  SPIN PRE ROLL
    //******************************************************************************************************************

    protected spinPreRoll(): void {
        if (this.currentSymbols != null) {
            for (let i: number = 0; i < this.currentSymbols.length; i++) {
                if (
                    this.currentSymbols[i].hasCase("START_ROTATION") &&
                    this.currentSymbols[i].getCurrentCase() !== Symbol.CaseEmpty
                ) {
                    this.currentSymbols[i].goToCase("START_ROTATION");
                }
            }
        }

        Tweens.removeTweens(this, "position");
        Tweens.positionTween(this, {
            tweenX: [this.positionX, this.positionX, this.positionX],
            tweenY: [this.positionY, this.positionY - this.preRoll, this.positionY],
            tweenDuration: this.preRollSpeed * 2,
            tweenDelay: this.startDelay,
            callbackFunction: this.spinRoll,
            callbackScope: this,
        });
    }

    //******************************************************************************************************************
    //  SHOW SYMBOLS, SPIN ROLL
    //******************************************************************************************************************

    protected updateReel(): void {
        this.returnSymbol(this.currentSymbols.pop());

        if (this.shouldBeStopping && !this.isStopping) {
            if (this.previousReel === null) {
                this.isStopping = true;
            } else if (this.previousReel.isStopping) {
                this.isStopping = true;
            }
        }

        this.stripIndex = (this.stripIndex - 1 + this.strip.length) % this.strip.length;

        let symbolId = this.strip[this.stripIndex];
        let symbolCase = Symbol.CaseBlur;

        if (this.isStopping) {
            if (this.stoppingCounter < this.symbolBottomCount) {
                symbolId =
                    this.strip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.strip.length) %
                            this.strip.length
                    ];
                symbolCase =
                    this.stoppingCounter === this.symbolBottomCount - 1 ? Symbol.CaseRotation : Symbol.CaseBlur;
            } else if (this.stoppingCounter < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
                symbolCase = Symbol.CaseRotation;

                if (
                    this.data.overlay &&
                    this.data.overlay[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1] != -1
                ) {
                    symbolCase = Symbol.CaseEmpty;

                    if (
                        this.data.transform &&
                        this.data.transform[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1] != -1
                    ) {
                        symbolCase = Symbol.CaseRotation;
                    }
                }
            } else {
                symbolId =
                    this.strip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.strip.length) %
                            this.strip.length
                    ];
                symbolCase =
                    this.stoppingCounter === this.symbolBottomCount + this.symbolCount
                        ? Symbol.CaseRotation
                        : Symbol.CaseBlur;
            }

            this.stoppingCounter++;
        }

        this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));

        // if(this.isStopping && symbolId==10 && symbolCase == Symbol.CaseRotation){
        //     (<any> this.currentSymbols[0]).elements.childs['Bird'].animate([{name: 'Empty'}]);
        // }

        this.addChild(this.currentSymbols[0]);

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }

        if (
            this.isStopping &&
            this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount
        ) {
            this.spinPostRoll();
        } else {
            this.spinRoll();
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected getSymbol(symbolId: number, symbolCase: string): Symbol {
        // if (symbolCase === Symbol.CaseRotation) {
        //     symbolCase = Symbol.CaseNormal;
        // }

        const symbol = super.getSymbol(symbolId, symbolCase);

        if (Reel2.Tease) {
            if (symbol.getCurrentCase() === Symbol.CaseBlur && symbol.id !== 12) {
                symbol.goToCase(Symbol.CaseNowin);
                symbol.alpha = 0.3;
            }
        } else {
            symbol.alpha = 1;
        }

        return symbol;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Reel2.ts
 **/